import { render, staticRenderFns } from "./ValidatableIncotermSelection.vue?vue&type=template&id=f9a12658&"
import script from "./ValidatableIncotermSelection.vue?vue&type=script&lang=js&"
export * from "./ValidatableIncotermSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports